import API from "./api"

const LOGIN = async (payload: any) => {
    const { data } = await API.post('/login', payload);

    return data;
}

const VALIDATE_RESET_TOKEN = async (payload: any) => {
    const { data } = await API.post('/validate', payload);

    return data;
}

const RESET_PASSWORD = async (payload: any) => {
    const { data } = await API.post('/reset', payload);

    return data;
}

export {
    LOGIN,
    VALIDATE_RESET_TOKEN,
    RESET_PASSWORD
}